import React, { FC } from 'react';

import { ButtonWithLogo } from '../ButtonWithLogo/ButtonWithLogo';
import SvgMapMarker from '../Icons/MapMarker';

interface GeolocationButtonProps {
  map: google.maps.Map | undefined;
  destination: google.maps.LatLngLiteral;
  className?: string;
}

const GeolocationButton: FC<GeolocationButtonProps> = ({ map, destination, className }) => {
  const handleClick = () => {
    if (navigator.geolocation && map) {
      navigator.geolocation.getCurrentPosition((position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        const userMarker = new google.maps.Marker({
          position: userLocation,
          map,
          title: 'Tu ubicación',
        });

        const directionsService = new google.maps.DirectionsService();
        const directionsRenderer = new google.maps.DirectionsRenderer();
        directionsRenderer.setMap(map);

        const request = {
          origin: userLocation,
          destination,
          travelMode: google.maps.TravelMode.DRIVING,
        };

        directionsService.route(request, (result, status) => {
          if (status === 'OK') {
            directionsRenderer.setDirections(result);
          }
        });
      });
    } else {
      alert('Geolocalización no soportada por tu navegador.');
    }
  };

  return (
    <button id="get_location_route_button" className={className} onClick={handleClick}>
      Mostrar mi ubicación y ruta
    </button>
  );
};

export default GeolocationButton;
